import React from 'react';
import { w3cwebsocket as W3CWebSocket } from "websocket";
import './App.css';

class App extends React.Component
{

  constructor(props){
    super(props);

    this.inputElement = React.createRef();
    this.selectInput = this.selectInput.bind(this);
    this.envoyerMessage = this.envoyerMessage.bind(this);

    this.client = new W3CWebSocket('ws://martinrabier.com:8780');

    this.state = {
      inputMsg : "",
      outputMsg : ""
    }
  }

  componentDidMount() {
    this.inputElement.current.focus();

    this.client.onopen = () => {
      console.log('WebSocket Client Connected');
     };

    this.client.onmessage = (message) => {
       const dataFromServer = JSON.parse(message.data);
       const stateToChange = {};
       if (dataFromServer.type === "userevent") {
          console.log("other connection");
       } else if (dataFromServer.type === "contentchange") {
        this.setState({ outputMsg: dataFromServer.data.editorContent });
       }

     };
  }


  selectInput(){
    this.inputElement.current.focus();
  }

  envoyerMessage(message){
    this.client.send(JSON.stringify({
      type: "contentchange",
      username: this.state.username,
      content: message
    }));
  }

  handleKeyUp = (evt) => {
    if (evt.keyCode === 13) {
      this.envoyerMessage(this.state.inputMsg);
      this.setState({ inputMsg: '' });
    }
  }

  handleInputChange = (evt) => this.setState({ inputMsg: evt.target.value });


  render(){
    return (
      <div className="App" onClick={this.selectInput}>
        <div className="livre">
          <div className="zoneInput">
            <textarea className="chatInput" onKeyUp={this.handleKeyUp} onChange={this.handleInputChange} value={this.state.inputMsg} ref={this.inputElement}/>
          </div>
          <div className="zoneMessage">
            {this.state.outputMsg}
          </div>
        </div>
      </div>
    );
  }
  
}

export default App;
